import FottServicesContainer from "@features/terminal-services/fott-services/FottServicesContainer";
import FottServiceRequestPage from "@pages/terminal-services/FottServiceRequestPage";
import TerminalServiceDetailsPage from "@pages/terminal-services/TerminalServiceDetailsPage";
import TerminalServicesPage from "@pages/terminal-services/TerminalServicesPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

export const getTerminalServicesRoutes = (): AppRoute => ({
  path: paths.terminalServices.index,
  protected: true,
  element: <TerminalServicesPage />,
  requiredPermissions: ["hasFottServiceAccess"],
  children: [
    { index: true, redirectTo: paths.terminalServices.fottServices },
    {
      path: paths.terminalServices.fottServices,
      element: <FottServicesContainer />,
    },
    {
      path: paths.terminalServices.terminalServiceDetailsById,
      element: <TerminalServiceDetailsPage />,
    },
    {
      path: paths.terminalServices.requestFottService,
      element: <FottServiceRequestPage />,
    },
  ],
});
